import { render, staticRenderFns } from "./imgOrVoiceOrVideoMaterial.vue?vue&type=template&id=c46fc056"
import script from "./imgOrVoiceOrVideoMaterial.vue?vue&type=script&lang=js"
export * from "./imgOrVoiceOrVideoMaterial.vue?vue&type=script&lang=js"
import style0 from "./imgOrVoiceOrVideoMaterial.vue?vue&type=style&index=0&id=c46fc056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports